/* eslint-disable */
import Long from 'long';
import _m0 from 'protobufjs/minimal';
import { TableCellData_VerticalAlignment } from './plugin_table_cell.enums';
export function tableCellData_VerticalAlignmentFromJSON(object) {
    switch (object) {
        case 0:
        case 'TOP':
            return TableCellData_VerticalAlignment.TOP;
        case 1:
        case 'MIDDLE':
            return TableCellData_VerticalAlignment.MIDDLE;
        case 2:
        case 'BOTTOM':
            return TableCellData_VerticalAlignment.BOTTOM;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TableCellData_VerticalAlignment.UNRECOGNIZED;
    }
}
export function tableCellData_VerticalAlignmentToJSON(object) {
    switch (object) {
        case TableCellData_VerticalAlignment.TOP:
            return 'TOP';
        case TableCellData_VerticalAlignment.MIDDLE:
            return 'MIDDLE';
        case TableCellData_VerticalAlignment.BOTTOM:
            return 'BOTTOM';
        default:
            return 'UNKNOWN';
    }
}
const baseTableCellData = {};
export const TableCellData = {
    fromJSON(object) {
        const message = Object.assign({}, baseTableCellData);
        message.cellStyle =
            object.cellStyle !== undefined && object.cellStyle !== null
                ? TableCellData_CellStyle.fromJSON(object.cellStyle)
                : undefined;
        message.borderColors =
            object.borderColors !== undefined && object.borderColors !== null
                ? TableCellData_BorderColors.fromJSON(object.borderColors)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.cellStyle !== undefined &&
            (obj.cellStyle = message.cellStyle
                ? TableCellData_CellStyle.toJSON(message.cellStyle)
                : undefined);
        message.borderColors !== undefined &&
            (obj.borderColors = message.borderColors
                ? TableCellData_BorderColors.toJSON(message.borderColors)
                : undefined);
        return obj;
    },
};
const baseTableCellData_CellStyle = {
    verticalAlignment: TableCellData_VerticalAlignment.TOP,
};
export const TableCellData_CellStyle = {
    fromJSON(object) {
        const message = Object.assign({}, baseTableCellData_CellStyle);
        message.verticalAlignment =
            object.verticalAlignment !== undefined && object.verticalAlignment !== null
                ? tableCellData_VerticalAlignmentFromJSON(object.verticalAlignment)
                : TableCellData_VerticalAlignment.TOP;
        message.backgroundColor =
            object.backgroundColor !== undefined && object.backgroundColor !== null
                ? String(object.backgroundColor)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.verticalAlignment !== undefined &&
            (obj.verticalAlignment = tableCellData_VerticalAlignmentToJSON(message.verticalAlignment));
        message.backgroundColor !== undefined && (obj.backgroundColor = message.backgroundColor);
        return obj;
    },
};
const baseTableCellData_BorderColors = {};
export const TableCellData_BorderColors = {
    fromJSON(object) {
        const message = Object.assign({}, baseTableCellData_BorderColors);
        message.left =
            object.left !== undefined && object.left !== null ? String(object.left) : undefined;
        message.right =
            object.right !== undefined && object.right !== null ? String(object.right) : undefined;
        message.top = object.top !== undefined && object.top !== null ? String(object.top) : undefined;
        message.bottom =
            object.bottom !== undefined && object.bottom !== null ? String(object.bottom) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.left !== undefined && (obj.left = message.left);
        message.right !== undefined && (obj.right = message.right);
        message.top !== undefined && (obj.top = message.top);
        message.bottom !== undefined && (obj.bottom = message.bottom);
        return obj;
    },
};
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
//# sourceMappingURL=plugin_table_cell.js.map